import { useState } from "react";
import Config from "../../Config";
import Invoices from "./Invoices";
import Transfers from "./Transfers";
import Calculate from "./Calculate";
import History from "./History";
//import Clients from "./Clients";




function CalculateView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


  
    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }



 

      if(props.mainView.viewSelected == 'invoices')
    {
        document.title ="Faktury"; 
        return (
            <div className="econtent ">                                  
                 <Invoices  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }


       if(props.mainView.viewSelected == 'transfers')
    {
        document.title ="Przelewy bankowe"; 
        return (
            <div className="econtent ">                                  
                 <Transfers  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }


    
    if(props.mainView.viewSelected == 'calculate')
    {
        document.title ="Rozliczenia"; 
        return (
            <div className="econtent ">                                  
                 <Calculate  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }


        
    if(props.mainView.viewSelected == 'history')
    {
        document.title ="Historia salda"; 
        return (
            <div className="econtent ">                                  
                 <History  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }



        return (
        <div className="econtent ">
             CalculateView - no selected menu position
        </div>
    );
}


export default CalculateView ;